import { render } from "./BorrowerFilter.vue?vue&type=template&id=5f338d58&scoped=true"
import script from "./BorrowerFilter.vue?vue&type=script&lang=js"
export * from "./BorrowerFilter.vue?vue&type=script&lang=js"

import "./BorrowerFilter.vue?vue&type=style&index=0&id=5f338d58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f338d58"]])

export default __exports__